module fdm.flightEvents {

    export type SeverityLevels = "Routine" | "Minor" | "Major" | "Critical" | "ExceedanceEvent";

    export class SeverityLevelService {

        private colors: any = { Routine: "#4AAFF4", Minor: "#D8D927", Major: "#F6810A", Critical: "#CE1955", ExceedanceEvent: '#F05050'};
        
        public constructor() {

        }

        public getColor(level: SeverityLevels): string {
            return this.colors[level];
        }
    }

    angular.module('fdm.flightEvents')
        .service('severityLevelService', SeverityLevelService);
}